import { Link } from 'react-router-dom';
import './AccessDeniedScreen.css';

interface AccessDeniedScreenProps {
  /** The page they tried to open, named so the message is about something specific. */
  pageName: string;
}

/**
 * Shown in place of a page the organization's admin has withheld from this user.
 *
 * The alternative — a silent redirect to /players — is indistinguishable from a broken link. A
 * coach following a colleague's link lands on the roster with no idea whether the page moved, the
 * link was wrong, or they are not allowed in, and support gets the ticket either way.
 *
 * This is presentation. The API refuses the same requests with `RequirePermissionAttribute`, which
 * is what actually stops a bookmark or a pasted URL.
 */
export const AccessDeniedScreen = ({ pageName }: AccessDeniedScreenProps) => (
  <div className="access-denied">
    <h1 className="access-denied__title">{pageName} is not available to you</h1>
    <p className="access-denied__message">
      Your organization&rsquo;s administrator has not given your account access to this page. Ask
      them to turn it on under Settings &rsaquo; Users.
    </p>
    <Link className="access-denied__link" to="/players">
      Back to Players
    </Link>
  </div>
);
